import { OrderStatus } from "../types";
export function getNotificationForStatus(status, orderId, trackingId) {
    const orderIdShort = orderId.slice(0, 8);
    const notifications = {
        [OrderStatus.PROCESSING]: {
            title: 'Order Processing',
            message: `Your order #${orderIdShort} is being processed.`,
            actionUrl: `/orders/${orderId}`,
        },
        [OrderStatus.CONFIRMED]: {
            title: 'Order Confirmed',
            message: `Your order #${orderIdShort} has been confirmed and is being prepared.`,
            actionUrl: `/orders/${orderId}`,
        },
        [OrderStatus.PACKED]: {
            title: 'Order Packed',
            message: `Your order #${orderIdShort} has been packed and is ready for pickup.`,
            actionUrl: `/orders/${orderId}`,
        },
        [OrderStatus.SHIPPED]: {
            title: 'Order Shipped',
            message: trackingId
                ? `Your order #${orderIdShort} has been shipped! Track it using: ${trackingId}`
                : `Your order #${orderIdShort} has been shipped!`,
            actionUrl: `/orders/${orderId}`,
        },
        [OrderStatus.OUT_FOR_DELIVERY]: {
            title: 'Out for Delivery',
            message: `Your order #${orderIdShort} is out for delivery and will arrive soon!`,
            actionUrl: `/orders/${orderId}`,
        },
        [OrderStatus.DELIVERED]: {
            title: 'Order Delivered',
            message: `Your order #${orderIdShort} has been delivered. Enjoy your books!`,
            actionUrl: `/orders/${orderId}`,
        },
        [OrderStatus.IN_TRANSIT]: {
            title: 'Order In Transit',
            message: `Your order #${orderIdShort} is on its way to you.`,
            actionUrl: `/orders/${orderId}`,
        },
        [OrderStatus.FAILED]: {
            title: 'Delivery Issue',
            message: `There was an issue delivering your order #${orderIdShort}. Please contact support.`,
            actionUrl: `/orders/${orderId}`,
        },
        // Don't send notifications for these statuses
        [OrderStatus.PLACED]: null,
        [OrderStatus.CANCELLED]: null,
        [OrderStatus.CANCELLATION_REQUESTED]: null,
        [OrderStatus.RETURNED]: null,
        [OrderStatus.PICK_UP_SCHEDULED]: null,
        [OrderStatus.PICKED_UP]: null,
    };
    return notifications[status] || null;
}
// function to get title for status history entry
export function getStatusTitle(status) {
    const titles = {
        [OrderStatus.PROCESSING]: 'Order Processing',
        [OrderStatus.PLACED]: 'Order Placed',
        [OrderStatus.CONFIRMED]: 'Order Confirmed',
        [OrderStatus.PACKED]: 'Order Packed',
        [OrderStatus.SHIPPED]: 'Order Shipped',
        [OrderStatus.OUT_FOR_DELIVERY]: 'Out for Delivery',
        [OrderStatus.DELIVERED]: 'Order Delivered',
        [OrderStatus.CANCELLED]: 'Order Cancelled',
        [OrderStatus.CANCELLATION_REQUESTED]: 'Cancellation Requested',
        [OrderStatus.RETURNED]: 'Order Returned',
        [OrderStatus.PICK_UP_SCHEDULED]: 'Pick-Up Scheduled',
        [OrderStatus.PICKED_UP]: 'Order Picked Up',
        [OrderStatus.IN_TRANSIT]: 'Order In Transit',
        [OrderStatus.FAILED]: 'Delivery Failed',
    };
    return titles[status] || status;
}
// function to get status style for order status badge  
export function getStatusStyle(status) {
    switch (status) {
        case OrderStatus.PLACED:
            return {
                color: 'text-slate-700',
                bg: 'bg-slate-100',
                icon: 'clock',
                label: getStatusTitle(status),
            };
        case OrderStatus.CONFIRMED:
            return {
                color: 'text-emerald-700',
                bg: 'bg-emerald-100',
                icon: 'check-circle',
                label: getStatusTitle(status),
            };
        case OrderStatus.PACKED:
            return {
                color: 'text-blue-700',
                bg: 'bg-blue-100',
                icon: 'package',
                label: getStatusTitle(status),
            };
        case OrderStatus.SHIPPED:
            return {
                color: 'text-indigo-700',
                bg: 'bg-indigo-100',
                icon: 'truck',
                label: getStatusTitle(status),
            };
        case OrderStatus.IN_TRANSIT:
            return {
                color: 'text-violet-700',
                bg: 'bg-violet-100',
                icon: 'truck',
                label: getStatusTitle(status),
            };
        case OrderStatus.OUT_FOR_DELIVERY:
            return {
                color: 'text-amber-700',
                bg: 'bg-amber-100',
                icon: 'truck',
                label: getStatusTitle(status),
            };
        case OrderStatus.DELIVERED:
            return {
                color: 'text-green-700',
                bg: 'bg-green-100',
                icon: 'check-circle',
                label: getStatusTitle(status),
            };
        case OrderStatus.PICK_UP_SCHEDULED:
            return {
                color: 'text-cyan-700',
                bg: 'bg-cyan-100',
                icon: 'calendar',
                label: getStatusTitle(status),
            };
        case OrderStatus.PICKED_UP:
            return {
                color: 'text-teal-700',
                bg: 'bg-teal-100',
                icon: 'check-circle',
                label: getStatusTitle(status),
            };
        case OrderStatus.CANCELLATION_REQUESTED:
            return {
                color: 'text-orange-700',
                bg: 'bg-orange-100',
                icon: 'alert-circle',
                label: getStatusTitle(status),
            };
        case OrderStatus.CANCELLED:
            return {
                color: 'text-red-700',
                bg: 'bg-red-100',
                icon: 'x-circle',
                label: getStatusTitle(status),
            };
        case OrderStatus.RETURNED:
            return {
                color: 'text-purple-700',
                bg: 'bg-purple-100',
                icon: 'rotate-ccw',
                label: getStatusTitle(status),
            };
        default:
            return {
                color: 'text-gray-700',
                bg: 'bg-gray-100',
                icon: 'info',
                label: getStatusTitle(status),
            };
    }
}
